const legacyRoleClaim = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export const normalizeRoles = roles => {
  if (typeof roles === "string") {
    return roles ? [roles] : [];
  }
  return Array.isArray(roles)
    ? roles.filter(role => typeof role === "string" && role.length > 0)
    : [];
};

// Prefer the new claim, while accepting profiles from the previous identity provider.
export const getProfileRoles = profile =>
  normalizeRoles(profile.role ?? profile[legacyRoleClaim]);
